import {
    convertFromUnits,
    convertToUnits,
    errorText,
    getMultiplier,
} from "components/Form/components/Duration/utils";
import { LabelledFormElement } from "components/Form/components/SchemaForm/LabelledFormElement";
import { fieldContainerClassName } from "components/Form/components/SchemaForm/SchemaFormService";
import { Text } from "components/Form/components/Text/Text";
import { useEffect, useState } from "react";

interface DurationFieldProps {
    errorMessage?: string;
    smallestUnitValue: "s" | "m" | "h" | "d";
    label: string;
    isReadOnly: boolean;
    labelProps: any;
    setFormData: (duration: number | null) => void;
    fieldValue?: number | null;
    actionButtons?: React.ReactNode;
}

export const DurationField = ({
    errorMessage,
    smallestUnitValue,
    label,
    labelProps,
    setFormData,
    fieldValue,
    isReadOnly,
    actionButtons,
}: DurationFieldProps) => {
    const [durationError, setDurationError] = useState("");

    useEffect(() => {
        const multiplier = getMultiplier(smallestUnitValue);
        const remainder = (fieldValue || 0) % multiplier[smallestUnitValue];
        if (remainder !== 0) {
            setDurationError(errorText(smallestUnitValue));
        } else {
            setDurationError("");
        }
    }, [fieldValue, smallestUnitValue]);

    useEffect(() => {
        const newValue = convertToUnits(smallestUnitValue, fieldValue);
        if (newValue !== displayedValue) {
            setDisplayedValue(newValue || "");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fieldValue]);

    const [displayedValue, setDisplayedValue] = useState(
        convertToUnits(smallestUnitValue, fieldValue) || ""
    );

    const containerProps = {
        ...labelProps,
        errorMessage: durationError || errorMessage,
    };
    return (
        <LabelledFormElement {...containerProps}>
            <div className={fieldContainerClassName(durationError)}>
                <Text
                    inputProps={{
                        onChange: (event) => {
                            setDisplayedValue(event.target.value);
                        },
                        onBlur: () => {
                            const convertedValue = convertFromUnits(
                                displayedValue,
                                smallestUnitValue,
                                durationError,
                                setDurationError
                            );
                            if (convertedValue !== undefined) {
                                setFormData(convertedValue);
                                setDurationError("");
                            }
                        },
                        value: displayedValue,
                        isReadOnly,
                    }}
                    name={`schemaForm.${label}`}
                    attributes={{ placeholder: "0d 0h 0m 0s" }}
                />
                {actionButtons}
            </div>
        </LabelledFormElement>
    );
};
